export const placeholderData = {
  records: [],
  count: 0,
} as const
